export default __webpack_public_path__ + "static/FooterBg-f59e947d2edfbb6a847b9b037c240468.svg";